import { apiService } from './api';
import { SageSupplierDetails, LinkExistingSageSupplierRequest } from '../types/sage';

/**
 * Service for finding and linking existing Sage suppliers to DRIS entities.
 * Used when Sage rejects supplier creation because the name already exists.
 */
export const sageSupplierLinkingService = {
  /**
   * Find an existing Sage supplier matching the entity's Sage name.
   * @param entityType The DRIS entity type (e.g. 'Lab', 'Agent', 'Farmer')
   * @param entityId The DRIS entity ID
   * @returns The matching Sage supplier details, or null if not found
   */
  findExistingSupplier: async (
    entityType: string,
    entityId: number,
    sageName?: string,
  ): Promise<SageSupplierDetails | null> => {
    try {
      const response = await apiService.get<SageSupplierDetails>(
        `/sage-supplier-linking/${entityType}/${entityId}/find-supplier`,
        sageName ? { sageName } : undefined,
      );
      return response.data ?? null;
    } catch {
      return null;
    }
  },

  /**
   * Link an existing Sage supplier to a DRIS entity and optionally sync data.
   * @param entityType The DRIS entity type
   * @param entityId The DRIS entity ID
   * @param request The link request containing sageSupplierId and syncDataToDris flag
   */
  linkExistingSupplier: async (
    entityType: string,
    entityId: number,
    request: LinkExistingSageSupplierRequest,
  ) => {
    return apiService.post(
      `/sage-supplier-linking/${entityType}/${entityId}/link-supplier`,
      request,
    );
  },
};
